document.addEventListener('DOMContentLoaded', () => {
  const header = document.getElementById('header-component');
  const columns = document.getElementById('columns');
  if (!header || !header.classList.contains('header--fade-border')) return;

  const SCROLL_THRESHOLD = 150; // <— Adjust here

  const onScroll = () => {
    if (window.scrollY > SCROLL_THRESHOLD) {
      header.classList.add('is-scrolled');
      columns.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
      columns.classList.remove('is-scrolled');
    }
  };

  window.addEventListener('scroll', onScroll);
  onScroll();
});
